<template>
  <viewed-employer-list/>
</template>

<script>
import ViewedEmployerList from '../components/ViewedEmployerList/index'
export default {
  components: {ViewedEmployerList  },

}
</script>

<style>

</style>
